import type { LocaleType } from "./en";

export const croLocale: LocaleType = {
  welcome: {
    title: "Dobrodošli u Vomi",
    subtitle: "Molimo unesite svoje ime za prikaz kako biste nastavili",
    displayNameLabel: "Ime za prikaz",
    displayNamePlaceholder: "Unesite svoje ime ili nadimak",
    continueButton: "Nastavi",
    logout: "Odjava",
    footer: "Vomi Poslovni Portal • Siguran pristup",
    validation: {
      nameRequired: "Molimo unesite svoje ime za prikaz",
    },
    success: {
      welcomeMessage:
        "Dobrodošli {name}! Funkcije aplikacije će biti dodane ovdje.",
    },
  },
  nativeLogin: {
    title: "Prijava",
    emailLabel: "Email",
    passwordLabel: "Lozinka",
    submit: "Prijavi se",
    invalidCredentials: "Neispravan email ili lozinka.",
    otpRequired: "Ovaj račun zahtijeva dodatnu potvrdu koja ovdje nije podržana. Prijavite se putem preglednika.",
    genericError: "Prijava nije uspjela. Pokušajte ponovno.",
    browserFallback: "Prijavi se putem preglednika",
  },
  toast: {
    error: "Greška",
    success: "Uspješno",
    defaultError: "Došlo je do greške",
    tracingIdPrefix: "ID greške",
    copyErrorId: "Kopiraj ID greške",
    errorIdCopied: "ID greške je kopiran.",
    errorIdCopyFailed: "Kopiranje nije uspjelo. Označite i kopirajte ID ručno.",
  },
  common: {
    loading: "Učitavanje...",
    error: "Došlo je do greške",
    notAvailable: "Nije dostupno",
    retry: "Pokušajte ponovno",
    back: "Natrag",
    cancel: "Odustani",
    save: "Spremi",
    close: "Zatvori",
    upload: "Učitaj",
    remove: "Ukloni",
    select: "Odaberi",
    edit: "Uredi",
    yes: "Da",
    no: "Ne",
    documentSaved: "Dokument spremljen",
    scrollLeft: "Pomakni ulijevo",
    scrollRight: "Pomakni udesno",
    documentOpenError: "Dokument je spremljen, ali ga nije moguće otvoriti.",
  },
  nav: {
    home: "Početna",
    add: "Zaposlenici",
    hours: "Sati",
    payroll: "Plaća",
    reports: "Izvještaji",
  },
  support: {
    buttonLabel: "Pomoć i povratne informacije",
    title: "Podijelite svoje mišljenje",
    requiredHint: "Obavezna polja označena su zvjezdicom.",
    typeLabel: "Odaberite vrstu povratne informacije",
    typePlaceholder: "Odaberite",
    textLabel: "Vaša poruka",
    textPlaceholder: "Ovdje upišite svoju poruku",
    submit: "Pošalji",
    types: {
      QUESTION: "Postavite pitanje",
      COMMENT: "Ostavite komentar",
      BUG: "Prijavite grešku",
      IMPROVEMENT: "Predložite poboljšanje",
    },
    validation: {
      typeRequired: "Odaberite vrstu povratne informacije.",
      textRequired: "Unesite tekst poruke.",
    },
    success: "Vaša poruka je uspješno poslana.",
    error: "Poruku trenutačno nije moguće poslati. Pokušajte ponovno.",
  },
  profile: {
    title: "Profil",
    logout: "Odjava",
    accountSettings: "POSTAVKE RAČUNA",
    clientSettings: "POSTAVKE KLIJENTA",
    email: "Email",
    phone: "Telefon",
    company: "Tvrtka",
    preferences: "PREFERENCE",
    language: "Jezik",
    signature: "Potpis",
    addSignature: "Dodaj potpis",
    notifications: "Obavijesti",
    manageNotifications: "Kontrolirajte svoje postavke obavijesti",
    assignedEmployees: "ZADUŽENI DJELATNICI",
    assignedEmployeeFinanceAndVat: "Financijsko i PDV",
    assignedEmployeeSalaryCalculation: "Obračun plaća",
    assignedEmployeeFinalReport: "Završni izvještaji",
    assignedEmployeeNotAssigned: "Djelatnik još nije dodijeljen.",
    legal: "Pravni dokumenti",
    legalOpenExternal: "Otvori u pregledniku",
    legalDocs: {
      uvjeti: "Uvjeti korištenja",
      privatnost: "Pravila privatnosti",
      kolacici: "Pravila kolačića",
      podizvrsitelji: "Popis podizvršitelja obrade",
      prihvatljivo: "Pravila prihvatljivog korištenja",
      sigurnost: "Sigurnost i prijava incidenta",
      impressum: "Podaci o pružatelju usluge",
    },
    security: "Sigurnost",
    securityDescription: "Lozinka, dvofaktorska autentikacija",
    annualHolidays: "Godišnji praznici",
    settingsAnnualHolidays: "Postavke godišnjih praznika",
    profilePicture: "Profilna slika",
    supportedFormats: "PNG, JPG ili GIF (max. 5MB)",
    currentProfilePicture: "Trenutna profilna slika",
    uploadedOn: "Preneseno",
    uploadNew: "Učitaj novu",
    editEmail: "Uredi email",
    emailAddress: "Email adresa",
    emailPlaceholder: "Unesite svoj email",
    editPhone: "Uredi broj telefona",
    phoneNumber: "Broj telefona",
    phonePlaceholder: "Unesite svoj broj telefona",
    editCompany: "Uredi tvrtku",
    companyName: "Naziv tvrtke",
    companyPlaceholder: "Unesite naziv tvrtke",
    selectLanguage: "Odaberi jezik",
    preferredLanguage: "Preferirani jezik",
    languagePlaceholder: "Odaberite jezik",
    electronicSignature: "Elektronski potpis",
    drawSignature: "Nacrtajte svoj potpis u okviru ispod",
    clearSignature: "Očisti",
    useTypedSignature: "Koristi upisani potpis",
    typeSignature: "Upišite svoj potpis",
    typeSignaturePlaceholder: "Upišite svoj potpis",
    saveSignature: "Spremi potpis",
    selectHolidayDates: "Odaberite datume godišnjih praznika",
    selectedDates: "Odabrani datumi",
    noDatesSelected: "Nema odabranih datuma",
    moreDates: "više datuma",
    saveHolidays: "Spremi praznike",
    holidaysDescription: "Pregled konfiguriranih državnih praznika.",
    holidayCountry: "Država praznika",
    holidayCountryCroatia: "Hrvatska",
    holidayCountryGermany: "Njemačka",
    notificationSettings: "Postavke obavijesti",
    notificationMessage: "Upravljanje obavijestima će uskoro biti dostupno.",
    securitySettings: "Sigurnosne postavke",
    securityMessage: "Upravljanje sigurnosnim postavkama će uskoro biti dostupno.",
    signatureSaved: "Spremljeno",
    currentSignature: "Trenutni potpis",
    updateSignature: "Ažuriraj potpis",
    fileTooLarge: "Veličina datoteke prelazi ograničenje od 5MB",
    invalidFileType: "Molimo prenesite valjanu sliku (JPG, PNG, GIF, WebP)",
    uploadFailed: "Prijenos datoteke nije uspio. Molimo pokušajte ponovno.",
    contactsTitle: "Kontakti",
    noContacts: "Nema kontakata",
    primaryContact: "Primarni",
    accountDetails: "Detalji računa",
    firstName: "Ime",
    lastName: "Prezime",
    companyDetails: "Detalji tvrtke",
    noCompanyData: "Nema podataka o tvrtki",
    businessType: "Vrsta subjekta",
    messages: {
      imageSaved: "Profilna slika uspješno spremljena",
      imageDeleted: "Profilna slika obrisana",
      signatureSaved: "Potpis uspješno spremljen",
    },
  },
  termsGate: {
    title: "Uvjeti korištenja",
    text: "Za nastavak korištenja aplikacije potrebno je prihvatiti aktualne Uvjete korištenja (verzija {version}).",
    open: "Otvori Uvjete korištenja",
    agree: "Pročitao/la sam i prihvaćam Uvjete korištenja.",
    continue: "Nastavi",
  },
  languages: {
    english: "Engleski",
    croatian: "Hrvatski",
    german: "Njemački",
  },
  months: {
    january: "Siječanj",
    february: "Veljača",
    march: "Ožujak",
    april: "Travanj",
    may: "Svibanj",
    june: "Lipanj",
    july: "Srpanj",
    august: "Kolovoz",
    september: "Rujan",
    october: "Listopad",
    november: "Studeni",
    december: "Prosinac",
  },
  days: {
    monday: "Ponedjeljak",
    tuesday: "Utorak",
    wednesday: "Srijeda",
    thursday: "Četvrtak",
    friday: "Petak",
    saturday: "Subota",
    sunday: "Nedjelja",
    mon: "Pon",
    tue: "Uto",
    wed: "Sri",
    thu: "Čet",
    fri: "Pet",
    sat: "Sub",
    sun: "Ned",
  },
  validation: {
    required: "Ovo polje je obavezno",
    invalidEmail: "Molimo unesite valjanu email adresu",
    invalidPhone: "Molimo unesite valjani broj telefona",
    minLength: "Mora imati najmanje {length} znakova",
    maxLength: "Mora imati manje od {length} znakova",
  },
  clientEmployees: {
    title: "Trenutni zaposlenici",
    searchPlaceholder: "Pretraži zaposlenike...",
    addEmployee: "Prijavi zaposlenika",
    editEmployee: "Uredi zaposlenika",
    confirmCancelMessage: "Jeste li sigurni da želite odustati? Svi uneseni podaci bit će izgubljeni.",
    noEmployees: "Nema pronađenih zaposlenika",
    firstName: "Ime",
    lastName: "Prezime",
    oib: "OIB",
    sortPlaceholder: "Sortiraj po…",
    sortDirectionLabel: "Promijeni smjer sortiranja",
    status: "Status",
    statusActive: "Aktivan",
    statusInactive: "Neaktivan",
    statusPending: "U pripremi",
    note: "Napomena",
    noteReminder: "Podsjetnik",
    pendingMessage: "Prijava je u obradi kod VOMI-ja. Ugovor će biti dostupan nakon završetka obrade.",
    street: "Ulica",
    houseNumber: "Kućni broj",
    city: "Grad",
    postalCode: "Poštanski broj",
    country: "Država",
    addressAddition: "Dodatak adresi",
    address: "Adresa",
    deactivate: "Deaktiviraj",
    terminate: "Odjava",
    terminateEmployee: "Odjava zaposlenika",
    archive: "Arhiviraj",
    showInactive: "Prikaži neaktivne",
    filterActive: "Aktivni",
    filterPending: "U pripremi",
    filterInactive: "Odjavljeni",
    noActiveEmployees: "Nema aktivnih zaposlenika",
    noPendingEmployees: "Nema zaposlenika u pripremi",
    noInactiveEmployees: "Nema odjavljenih zaposlenika",
    noSearchResults: "Nema rezultata za pretragu",
    deactivateConfirmTitle: "Deaktiviraj zaposlenika",
    deactivateConfirmMessage:
      "Jeste li sigurni da želite deaktivirati ovog zaposlenika?",
    archiveConfirmTitle: "Arhiviraj zaposlenika",
    archiveConfirmMessage:
      "Jeste li sigurni da želite arhivirati ovog zaposlenika?",
    formValidation: {
      requiredHint: "Obavezna polja označena su zvjezdicom (*).",
      fixErrors: "Nije moguće nastaviti — ispravite polja označena crvenom bojom.",
      firstNameRequired: "Unesite ime.",
      lastNameRequired: "Unesite prezime.",
      streetRequired: "Unesite ulicu.",
      houseNumberRequired: "Unesite kućni broj.",
      cityRequired: "Unesite grad.",
      postalCodeRequired: "Unesite poštanski broj.",
      countryRequired: "Unesite državu.",
      oibRequired: "Unesite OIB.",
      oibInvalid: "Unesite OIB u ispravnom formatu (11 znamenki).",
    },
    onboarding: {
      title: "Prijava zaposlenika",
      subtitle: "Upravljajte prijavom novih zaposlenika i dokumentacijom",
      requiredDocuments: "Potrebni dokumenti",
      documentsLabel: "Dokumenti",
      formTitle: "Podaci o zaposleniku",
      documents: {
        personalId: "Osobna iskaznica i osnovni podaci",
        personalIdDesc: "Osobni dokumenti i osnovne informacije",
        taxCard: "Porezna kartica",
        taxCardDesc: "Porezni dokumenti i kartice",
        iban: "IBAN redovnog i zaštićenog računa",
        ibanDesc: "Bankovni računi za isplatu plaće",
        workRecord: "Elektronički zapis radnog staža",
        workRecordDesc: "Digitalni zapis radnog iskustva",
        workPermit: "Radna dozvola",
        workPermitDesc: "Sken ili fotografija važeće radne dozvole",
        upload: "Učitaj",
        uploadHint: "PDF, JPG ili PNG, maks. 5MB",
        uploaded: "Učitano",
        required: "Obavezno",
        optional: "Opcionalno",
        deadlineDays: "Rok: 5 dana",
        fileTooLarge: "Datoteka prevelika (maks. 5MB)",
        uploadSuccess: "Dokumenti uspješno poslani",
        requiredDocsMessage: "Učitajte osobnu iskaznicu",
        pendingDocs: "Nedostaju dokumenti",
        sendDocuments: "Pošalji dokumente",
        deadlineRemaining: "{documents} — još {days} dana za upload",
        deadlineRemainingOne: "{documents} — još {days} dan za upload",
        deadlineExpired: "{documents} — rok za upload je istekao!",
        ibanChoose: "Kako želite dodati IBAN?",
        ibanUploadFile: "Učitaj dokument",
        ibanEnterManually: "Unesite IBAN ručno",
        ibanPlaceholder: "HR1234567890123456789",
        ibanManuallyEntered: "IBAN ručno unesen",
        ibanValidation: "Unesite ispravan IBAN (HR + 19 znamenki)",
      },
      actions: {
        chooseAction: "Odaberite akciju",
        change: "Promjena",
        deactivate: "Deaktiviraj",
        terminate: "Odjava",
        archive: "Arhiviraj",
      },
    },
    actions: {
      header: "Akcije",
      edit: "Promjena",
      deactivate: "Deaktiviraj",
      archive: "Arhiviraj",
    },
    contract: {
      title: "Ugovor o radu",
      contractStartDate: "Datum početka ugovora",
      jobTitle: "Naziv radnog mjesta",
      jobTitlePlaceholder: "npr. Računovođa",
      contractType: "Vrsta ugovora",
      fullTime: "Puno radno vrijeme",
      partTime: "Nepuno radno vrijeme",
      workingHours: "Broj sati tjedno",
      workingHoursPlaceholder: "npr. 20 ili 20:00",
      scheduleType: "Raspored radnog vremena",
      scheduleFixed: "Fiksno",
      scheduleAgreement: "Prema dogovoru",
      scheduleShift: "Smjenski rad",
      shift: {
        typeLabel: "Vrsta smjenskog rada",
        daily: "Dnevne smjene",
        dailyHint: "Radno vrijeme definira se po danima",
        weekly: "Tjedne smjene",
        weeklyHint: "Smjene se automatski rotiraju po tjednima",
        dailySectionTitle: "Radno vrijeme po danima",
        days: {
          MONDAY: "Pon",
          TUESDAY: "Uto",
          WEDNESDAY: "Sri",
          THURSDAY: "Čet",
          FRIDAY: "Pet",
          SATURDAY: "Sub",
          SUNDAY: "Ned",
        },
        start: "Početak",
        end: "Kraj",
        dayOff: "slobodno",
        workingDay: "Radni dan",
        freeDay: "Slobodan dan",
        copyMonday: "Kopiraj ponedjeljak na radne dane",
        fundOver: "{diff} više od ugovorenog fonda ({fund})",
        fundUnder: "{diff} manje od ugovorenog fonda ({fund})",
        weeklyTotal: "Ukupno tjedno",
        rotationSectionTitle: "Smjene u rotaciji",
        shiftName: "Naziv smjene",
        unnamedShift: "(bez naziva)",
        newShiftName: "{n}. smjena",
        addShift: "Dodaj smjenu",
        removeShift: "Ukloni smjenu",
        workingDays: "Radni dani u tjednu",
        workingDaysHint: "Svaka smjena ima svoje radne dane — npr. jedan tjedan 5, drugi 6 dana. Gumbom 5 ili 6 dana postavljate zadani raspored (kod 6 dana kraća subota), a dane i vremena zatim uredite. Svaki tjedan mora dati ugovoreni fond.",
        firstWeekShift: "Smjena u prvom tjednu ugovora",
        firstWeekShiftHint: "Rotacija se računa od tjedna u kojem ugovor počinje i nastavlja redom kroz sve smjene.",
        previewTitle: "Pregled rotacije (prvih 6 tjedana)",
        previewWeek: "{n}. tjedan",
        previewNeedsStartDate: "Pregled rotacije prikazuje se nakon odabira datuma početka ugovora.",
        perShiftWeekly: "Tjedno po smjeni",
        contractedFund: "Ugovoreni fond",
        validation: {
          dailyNoDays: "Za dnevne smjene potrebno je označiti barem jedan radni dan.",
          invalidTime: "Početak i kraj smjene moraju biti u formatu HH:MM.",
          sameStartEnd: "Početak i kraj smjene ne smiju biti isti.",
          weeklyMinTwoShifts: "Za tjedne smjene potrebno je definirati barem dvije smjene.",
          weeklyFirstShiftRequired: "Odaberite smjenu u prvom tjednu ugovora.",
          weeklyShiftNameRequired: "Naziv smjene je obavezan.",
          weeklyNoDays: "Smjena „{name}“ mora imati barem jedan radni dan.",
          weeklyUnequalShifts: "Sve smjene u rotaciji moraju imati jednako tjedno trajanje.",
          dailyFundMismatch: "Ukupno tjedno mora odgovarati ugovorenom fondu od {expected} (unijeli ste {total}).",
          weeklyFundMismatch: "Tjedno po smjeni mora odgovarati ugovorenom fondu od {expected} (unijeli ste {total}).",
        },
      },
      weeklyScheduleType: "Tjedni raspored",
      fiveDaySchedule: "Peterodnevni (pon-pet)",
      sixDaySchedule: "Šesterodnevni (pon-sub)",
      sixDayScheduleHint: "Subota se računa kao redovan radni dan (nije prekovremeni).",
      contractDuration: "Trajanje ugovora",
      durationIndefinite: "Na neodređeno",
      durationDefinite: "Na određeno",
      reason: "Razlog za ugovor na određeno",
      reasonPlaceholder: "npr. Zamjena za bolovanje",
      vacationDays: "Godišnji odmor (broj dana)",
      vacationDaysPlaceholder: "min. 20",
      proportionalVacationDays: "Razmjerni godišnji odmor",
      proportionalVacationDaysNote: "Zaposleniku zaposlenom na određeno pripada razmjerni dio godišnjeg odmora, koji se izračunava prema trajanju radnog odnosa.",
      salaryType: "Tip plaće",
      salaryTypeBruto: "Bruto",
      salaryTypeNeto: "Neto",
      monthlyGrossSalary: "Mjesečna bruto plaća (EUR)",
      salaryPlaceholder: "Iznos bruto plaće",
      salaryNote: "Bruto plaća nije konačan trošak — doprinos za zdravstveno se obračunava dodatno.",
      minimumGrossSalaryNote: "Minimalni iznos bruto plaće iznosi {amount} (vrijednost se preuzima iz postavki sustava).",
      minimumGrossSalaryPartTimeNote: "Za nepuno radno vrijeme minimalna bruto plaća razmjerna je tjednom broju sati: {percent} % od {full} = {amount}.",
      desiredNetSalary: "Željeni neto iznos plaće (EUR)",
      desiredNetSalaryPlaceholder: "min. {amount}",
      desiredNetSalaryPartTimeNote: "Za nepuno radno vrijeme minimalni neto iznos razmjeran je tjednom broju sati: {percent} % od {full} € = {amount} €.",
      desiredNetSalaryNote: "Konačan neto iznos plaće ovisi o poreznim pravilima grada/općine prebivališta zaposlenika te će možda biti potrebna korekcija. Vomi će ugovor o radu izraditi s odgovarajućim bruto iznosom, uzimajući u obzir uneseni željeni neto iznos.",
      allowances: "Neoporezivi dodaci uz plaću (opcijski)",
      transportCost: "Prijevoz (EUR/mj)",
      transportCostNote: "Do stvarnog iznosa mjesečne karte",
      mealAllowance: "Topli obrok (EUR/mj)",
      mealAllowanceNote: "Do {limit} EUR mjesečno",
      performanceBonus: "Nagrada za radne rezultate (EUR/mj)",
      performanceBonusNote: "Do {limit} EUR godišnje",
      occasionalBonus: "Prigodna nagrada (EUR/mj)",
      occasionalBonusNote: "Do {limit} EUR godišnje",
      mealAllowanceWarn: "Upozorenje: preporučeni maksimalni iznos za topli obrok je {limit} EUR mjesečno",
      performanceBonusWarn: "Upozorenje: preporučeni maksimalni iznos za nagradu za radne rezultate je {limit} EUR godišnje",
      occasionalBonusWarn: "Upozorenje: preporučeni maksimalni iznos za prigodnu nagradu je {limit} EUR godišnje",
      workingHoursFormat: "Tjedno nepuno radno vrijeme u satima ili u formatu HH:MM (00:01–39:59)",
      workingHoursInvalid: "Unesite tjedno radno vrijeme u formatu HH:MM (00:01–39:59)",
      contractStartDateRequired: "Unesite datum početka rada.",
      contractStartDateInvalid: "Datum početka ugovora mora biti danas ili kasnije (poslije 14 sati sutra ili kasnije), a najviše 30 dana unaprijed.",
      contractStartDateHint: "Prijava s današnjim datumom moguća je samo do 14:00h — nakon toga najraniji mogući datum je sutra.",
      jobTitleRequired: "Unesite naziv radnog mjesta.",
      workingHoursRequired: "Unesite broj sati tjedno za nepuno radno vrijeme.",
      reasonRequired: "Unesite razlog za ugovor na određeno.",
      vacationDaysRequired: "Unesite broj dana godišnjeg odmora.",
      vacationDaysMin: "Minimalni broj dana godišnjeg odmora je {min}.",
      salaryRequired: "Unesite iznos bruto plaće.",
      salaryPositive: "Iznos mora biti veći od 0.",
      salaryBelowMinimum: "Bruto plaća za puno radno vrijeme ne smije biti manja od {amount}.",
      salaryBelowPartTimeMinimum: "Bruto plaća za upisano nepuno radno vrijeme ne smije biti manja od {amount}.",
      desiredNetSalaryRequired: "Željeni neto iznos plaće je obavezan.",
      desiredNetSalaryBelowMinimum: "Minimalni neto iznos plaće iznosi {amount} €.",
      amountNotNegative: "Iznos ne smije biti negativan.",
      notDefined: "Ugovor nije definiran",
      editDisabled: "Uređivanje ugovora bit će dostupno u budućem ažuriranju (aneks)",
      editTitle: "Uredi ugovor",
      changesRequireAmendment: "Ova promjena zahtijeva aneks ugovora",
      changesRequireNewContract: "Ova promjena zahtijeva novi ugovor o radu",
      changeRejected: "Ova promjena nije dopuštena. Trajanje ugovora ne može iz Određeno u Neodređeno.",
      contractTypeLockedHint: "Vrsta ugovora zaključana je na nepuno radno vrijeme zbog dodatnog rada",
      updateSuccessEdit: "Ugovor je ažuriran",
      updateSuccessAnnex: "Aneks ugovora kreiran. PDF se generira.",
      updateSuccessNewContract: "Novi ugovor o radu kreiran. PDF se generira.",
      updateError: "Greška pri ažuriranju ugovora",
      annexForSigningTitle: "Aneks za potpis",
      newContractForSigningTitle: "Novi ugovor za potpis",
      newContractDownload: "Preuzmi novi ugovor",
      newContractConfirmAction: "Potpiši novi ugovor",
      newContractConfirmedBadge: "Novi ugovor potpisan",
      annexForSigningHint: "Dokument treba dati radniku na potpis i dostaviti u računovodstvo ili arhivirati kod sebe.",
      annexConfirmAction: "Potpiši aneks",
      annexConfirmedBadge: "Aneks potpisan",
      annexNotReadyYet: "Aneks još nije spreman. Bit ćete obaviješteni kad VOMI pripremi dokument.",
      annexDownload: "Preuzmi aneks",
      annexConfirmSuccess: "Aneks je uspješno potvrđen.",
      annexConfirmError: "Greška pri potvrđivanju aneksa.",
      history: "Povijest ugovora",
      noHistory: "Nema prethodnih verzija ugovora",
      historyVersionNew: "Originalni ugovor",
      historyVersionEdit: "Izmjena ugovora",
      annexAppliedBadge: "Verzija s aneksom",
      newContractAppliedBadge: "Novi ugovor",
      historyChangeDate: "Datum promjene",
      historyDetailsTitle: "Detalji ugovora",
      historyViewDetails: "Prikaži detalje",
      downloadContract: "Preuzmi ugovor",
      isForeigner: "Stranac",
      firstEmploymentReliefQuestion: "Korištenje olakšice na doprinose (prvo zaposlenje)",
      firstEmploymentReliefHint: "Uvjet: ugovor na neodređeno vrijeme.",
      citizenshipQuestion: "Državljanstvo",
      citizenshipEu: "EU / EGP / Švicarska",
      citizenshipThirdCountry: "Treća zemlja",
      workPermitQuestion: "Ima li osoba važeću radnu dozvolu koju je ishodila vaša tvrtka ili obrt?",
      workPermitHasPermit: "Osoba ima važeću radnu dozvolu",
      workPermitNoPermit: "Osoba nema radnu dozvolu",
      workPermitRequired: "Prilaganje radne dozvole je obavezno.",
      workPermitBlockedTitle: "Prijava nije moguća",
      workPermitBlockedMessage: "Radnika nije moguće prijaviti bez važeće radne dozvole. Kontaktirajte Vomi d.o.o. radi provjere uvjeta koje moraju ispuniti poslodavac i radnik. Vomi d.o.o. može vam ponuditi uslugu apliciranja za radnu dozvolu.",
      workPermitUploadAfterApproval: "Radna dozvola bit će zatražena nakon što Master odobri ovaj zahtjev.",
      isAdditionalWork: "Dodatni rad",
      additionalWorkMaxHours: "Dodatni rad može trajati najviše 8 sati tjedno.",
      worksSaturday: "Radi subotom",
      worksSaturdayRequiresSixDay: "Rad subotom moguć je samo uz šesterodnevni tjedni raspored.",
      worksSaturdayRequiresFullTimeFixed: "Rad subotom moguć je samo uz puno radno vrijeme i fiksni raspored.",
      worksSaturdayLegacy: "Zatečena postavka s ranijeg ugovora. Ostaje kakva jest, ali se više ne može ponovno uključiti.",
      worksSaturdayAdditionalWork: "Kod dodatnog rada rad subotom možete uključiti po potrebi. Subota ulazi u tjedni fond od najviše 8 sati, a raspored je tada \"Prema dogovoru\".",
      agreementScheduleSaturdayHint: "Kod rasporeda prema dogovoru radni dani, uključujući subotu, upisuju se ručno u evidenciju radnog vremena.",
      passportNumber: "Broj putovnice",
      passportNumberPlaceholder: "npr. AB1234567",
      passportNumberRequired: "Unesite broj putovnice (obavezno za strane državljane).",
      probationPeriod: "Probni rad (mjeseci)",
      probationPeriodRange: "Probni rad mora biti između 1 i 6 mjeseci. Ako radni odnos traje kraće od jednog mjeseca, ovo polje ostavite prazno.",
      probationPeriodExceedsContract: "Probni rad ne smije biti dulji od trajanja ugovora na određeno.",
      probationPeriodShortContractHint: "Ako radni odnos traje kraće od jednog mjeseca, ovo polje ostavite prazno.",
      probationPeriodShortContract: "Radni odnos traje kraće od jednog mjeseca — ovo polje ostavite prazno.",
      workLocation: "Mjesto rada",
      workLocationPlaceholder: "npr. Zagreb",
      contractEndDate: "Datum isteka ugovora",
      contractEndDateRequired: "Unesite datum isteka ugovora na određeno.",
      workStartTime: "Početak rada",
      workEndTime: "Kraj rada",
      workStartTimePlaceholder: "08:00",
      workEndTimePlaceholder: "16:00",
      workEndTimeAutoCalculated: "Izračunava se automatski iz početka rada i broja sati tjedno.",
      workEndTimeAutoCalculatedMismatch: "Kraj rada mora biti {time} (početak rada + broj sati tjedno / 5).",
      workTimeFormat: "Format HH:MM (00:00–23:59)",
      workTimeInvalid: "Unesite vrijeme u formatu HH:MM (00:00–23:59).",
      workEndAfterStart: "Kraj rada mora biti nakon početka rada.",
      workStartTimeRequired: "Ovo je polje obvezno kod odabira fiksnog radnog vremena.",
      workEndTimeRequired: "Ovo je polje obvezno kod odabira fiksnog radnog vremena.",
      fixedScheduleHint: "Kod fiksnog radnog vremena potrebno je popuniti sva pripadajuća polja označena zvjezdicom (vrijeme početka i završetka rada).",
      workTimeFullTimeSpanInvalid: "Za puno radno vrijeme raspon radnog vremena mora biti {hours}h.",
      partTimeSixDayFixedDisabled: "Fiksni raspored nije moguć uz rad subotom kod nepunog radnog vremena. Koristite 'Prema dogovoru' i unesite sate ručno po danu.",
      workingHoursNotDivisibleBy5: "Broj sati tjedno nije djeljiv s 5 (broj radnih dana). Koristite 'Prema dogovoru' umjesto 'Fiksno' i unesite sate ručno po danu.",
      downloadDisabled: "Generiranje dokumenta ugovora bit će dostupno u budućem ažuriranju",
      documentSection: "Dokument ugovora",
      notReadyYet: "Dokument još nije spreman. Bit ćete obaviješteni kad VOMI pripremi ugovor.",
      confirmDocument: "Potpiši dokument",
      signatureRequired: "Postavite digitalni potpis u profilu da biste mogli potvrditi dokument.",
      confirmHint: "Dokument treba dati radniku na potpis i dostaviti u računovodstvo ili arhivirati kod sebe.",
      confirmedBadge: "Potpisano",
      downloadError: "Greška pri preuzimanju dokumenta.",
      confirmSuccess: "Dokument je potvrđen.",
      confirmError: "Greška pri potvrdi dokumenta.",
      alreadyConfirmed: "Dokument je već potvrđen.",
    },
    detail: {
      personalData: "Osobni podaci",
      tabs: {
        overview: "Pregled",
        contract: "Ugovor",
        absences: "Odsutnosti",
        hours: "Radni sati",
        nonTaxable: "Neoporezivi primici",
      },
      absencesPlaceholder: "Odsutnosti — uskoro dostupno",
      absencesSubtext: "Bolovanje i godišnji odmor",
      hoursPlaceholder: "Radni sati — uskoro dostupno",
      hoursSubtext: "Evidencija radnog vremena",
      salarySection: "Plaća i naknade",
      workTime: {
        title: "Radni sati",
        periodLabel: "Mjesec i godina",
        empty: "Nema podataka za odabrani period",
        pendingMessage: "Zaposlenik još nije potvrđen od strane VOMI-ja. Radni sati bit će dostupni nakon potvrde prijave.",
        noDays: "Za odabrani mjesec nema dnevnih zapisa — zaposlenik je bio izvan evidencije radnog vremena (npr. dugotrajna odsutnost).",
        lockedMessage: "Radni sati i datum obračuna plaće nisu dostupni za uređivanje jer je obračun plaće u tijeku ili je završen. Za izmjene je potrebno kontaktirati Vomi d.o.o.",
        loading: "Učitavanje radnih sati...",
        error: "Greška pri učitavanju radnih sati",
        retry: "Pokušajte ponovno",
        plannedShiftHint: "Radno vrijeme po ugovoru — dan nije ručno unesen",
        shiftWeeks: {
          title: "Smjene po tjednima",
          hint: "Tjedni idu po rotaciji iz ugovora. Za tekući i buduće tjedne možete odabrati drugu smjenu — vrijedi samo za taj tjedan.",
          changed: "Promijenjeno ručno",
          resetToRotation: "Vrati na rotaciju",
          saved: "Smjena za tjedan spremljena",
        },
        dayType: {
          REGULAR: "Radni dan",
          WEEKEND: "Vikend",
          HOLIDAY: "Blagdan",
          VACATION: "Godišnji odmor",
          SICK_LEAVE: "Bolovanje",
        },
        columns: {
          date: "Datum",
          type: "Vrsta",
          start: "Početak",
          end: "Kraj",
          regular: "Redovni",
          overtime: "Prekovremeni",
          night: "Noćni",
        },
        totals: {
          regular: "Ukupno redovni",
          overtime: "Ukupno prekovremeni",
          night: "Ukupno noćni",
        },
        form: {
          startTime: "Početak",
          endTime: "Kraj",
          overtimeMinutes: "Prekovremeni",
          overtimeUnit: "min",
          egPrefix: "npr.",
          invalidTime: "Unesite ispravno vrijeme (00:00–23:59)",
          invalidOvertime: "Prekovremeni mora biti nenegativan broj",
          exceedsDailyFond: "Uneseno radno vrijeme prelazi definirani dnevni fond zaposlenika od {max} sati.",
          exceedsWeeklyRegular: "Ovaj tjedan preostalo je još {remaining} h redovnog rada (najviše {max} h tjedno). Ostatak upišite kao prekovremeni.",
          weeklyRegularFull: "Tjedni fond od {max} h redovnog rada je popunjen — cijela smjena evidentira se kao prekovremeni rad.",
          saturdayOvertime: "Cijela subota evidentira se kao prekovremeni rad; dodatne sate unesite produljenjem radnog vremena.",
          exceedsYearlyOvertime: "Godišnji prekovremeni rad iznosio bi {total} h, a najviše je dopušteno {max} h.",
          yearlyOvertimeWarning: "Godišnji prekovremeni rad iznosit će {total} h. Zakonski godišnji limit je {warning} h, osim ako je kolektivnim ugovorom definirano više (najviše {max} h).",
          editTitle: "Unos radnog vremena",
        },
        actions: {
          edit: "Uredi",
          save: "Spremi",
          cancel: "Odustani",
          delete: "Obriši unos",
          notWorked: "Nije radio/la",
        },
        source: {
          MANUAL: "Ručno",
          PENDING: "Čeka unos",
        },
        toast: {
          saved: "Unos uspješno spremljen",
          deleted: "Unos uspješno obrisan",
        },
      },
    },
    nonTaxable: {
      title: "Neoporezivi primici",
      type: "Vrsta primitka",
      oneOffTitle: "Jednokratna isplata",
      paymentsTitle: "Isplate",
      noPayments: "Za ovu vrstu primitka nema evidentiranih isplata.",
      amount: "Iznos (EUR)",
      payoutOption: "Način isplate",
      uzPlacu: "Uz sljedeću plaću",
      naDatum: "Na datum",
      payoutDate: "Datum isplate",
      submit: "Pošalji",
      confirm: "Potvrdi",
      downloadDecision: "Preuzmi odluku",
      recurringAmount: "Fiksni mjesečni iznos (EUR)",
      recurringNote: "Isplaćuje se svaki mjesec dok se ne promijeni ili ukloni.",
      recurringValidFrom: "Vrijedi od",
      recurringRemoval: "Uklanjanje fiksnog iznosa",
      recurringPending: "Čeka odobrenje: {amount}",
      recurringPendingRemoval: "Uklanjanje čeka odobrenje",
      recurringAction: {
        UPSERT: "izmjena",
        DELETE: "uklanjanje",
      },
      remainingYear: "Preostalo za ovu godinu: {remaining} od {limit}",
      remainingMonth: "Preostalo ovaj mjesec: {remaining} od {limit}",
      usedThisYear: "Isplaćeno ove godine: {used} (bez zakonskog limita)",
      usedThisMonth: "Isplaćeno ovaj mjesec: {used} (do stvarnog iznosa mjesečne karte)",
      previousEmployerMonth:
        "Od toga {amount} zaposlenik je ovaj mjesec već primio kod prethodnog poslodavca.",
      previousEmployerYear:
        "Od toga {amount} zaposlenik je ove godine već primio kod prethodnog poslodavca.",
      emailNotice: "Nakon što klijent potvrdi isplatu, VOMI-ju se šalje email.",
      otherType: "Naziv vrste primitka",
      otherTypePlaceholder: "npr. Jubilarna nagrada",
      types: {
        PRIJEVOZ: "Prijevoz",
        TOPLI_OBROK: "Topli obrok",
        NAGRADA_ZA_RADNE_REZULTATE: "Nagrada za radne rezultate",
        PRIGODNA_NAGRADA: "Prigodna nagrada",
        OSTALO: "Ostalo",
      },
      statuses: {
        PENDING_APPROVAL: "Čeka odobrenje",
        DRAFT: "Čeka potpis",
        CONFIRMED: "Potvrđeno",
      },
      validation: {
        recurringRequired: "Unesite mjesečni iznos.",
        amountPositive: "Iznos mora biti veći od nule.",
        amountOverLimit: "Iznos prelazi preostali limit.",
        otherTypeRequired: "Naziv vrste primitka je obavezan.",
        payoutDateRequired: "Datum isplate je obavezan.",
      },
      toast: {
        created: "Isplata je evidentirana",
        confirmed: "Isplata je potvrđena",
        recurringSaved: "Fiksni mjesečni iznos je spremljen",
        recurringRemoved: "Fiksni mjesečni iznos je uklonjen",
        recurringPending: "Zahtjev je poslan na odobrenje",
      },
    },
    absences: {
      title: "Odsutnosti",
      subtitle: "Godišnji odmor, bolovanje i dugotrajna odsutnost",
      loading: "Učitavanje...",
      toast: {
        created: "Zahtjev je kreiran",
        confirmed: "Odsutnost je potvrđena",
        updated: "Odsutnost je ažurirana",
        cancelled: "Odsutnost je stornirana",
        deleted: "Zahtjev je obrisan",
        changeRequested: "Zahtjev je poslan Masteru na odobrenje",
      },
      header: {
        vacationRemaining: "Preostalo dana godišnjeg",
        daysShort: "dana",
        of: "od",
      },
      carryOver: {
        summary: "uklj. {days} {dayWord} prenesenih iz {year}., iskoristiti do {date}",
        detail: "Preneseno iz {year}.: {days} {dayWord} — moraju se iskoristiti do {date}, inače se gube.",
        consumed: "Svi preneseni dani iz {year}. ({days}) su iskorišteni.",
        expired: "{days} {dayWord} prenesenih iz {year}. nije iskorišteno do {date} i više se ne mogu koristiti.",
        overdue: "Rok {date} je prošao, a {days} {dayWord} prenesenih iz {year}. još nije iskorišteno — iskoristite ih što prije.",
      },
      tabs: {
        vacation: "Godišnji odmor",
        sickLeave: "Bolovanje",
        longTermAbsence: "Dugotrajna odsutnost",
        other: "Ostalo",
      },
      type: {
        VACATION: "Godišnji odmor",
        SICK_LEAVE: "Bolovanje",
        LONG_TERM_ABSENCE: "Dugotrajna odsutnost",
        OTHER: "Ostalo",
      },
      changeAction: {
        EDIT: "Izmjena",
        EXTEND: "Produženje",
        CANCEL: "Storniranje",
      },
      status: {
        PENDING_APPROVAL: "Čeka odobrenje",
        DRAFT: "U pripremi",
        CONFIRMED: "Potvrđeno",
        ACTIVE: "Aktivno",
        CANCELLED: "Stornirano",
        // Derived on the client for a long-term absence whose end date has passed; not a stored status.
        ENDED: "Završeno",
      },
      actions: {
        submit: "Pošalji zahtjev",
        confirm: "Potvrdi",
        downloadPdf: "Preuzmi PDF",
        cancel: "Storniraj",
        edit: "Uredi",
        editEndDate: "Uredi datum završetka",
        extend: "Produži",
        save: "Spremi",
      },
      cancelConfirm: {
        title: "Storniranje zahtjeva",
        message: "Želite li stornirati zahtjev za godišnji odmor za razdoblje od {start} do {end}?",
        accept: "Storniraj zahtjev",
        reject: "Odustani",
      },
      vacation: {
        startDate: "Datum od",
        endDate: "Datum do",
        legalBasis: "Pravna osnova (opcionalno)",
        remaining: "Preostalo: {days} {dayWord}",
        note: "Vikendi i blagdani se ne računaju u godišnji odmor.",
        marked: "Označeno: {marked} {dayWord}, preostalo: {remaining}",
        budgetWarning: "Upozorenje: prelazite raspoloživi broj dana godišnjeg odmora.",
        pickRange: "Odaberite raspon datuma u kalendaru",
        editTitle: "Uredi godišnji odmor",
      },
      sickLeave: {
        startDate: "Datum od",
        endDate: "Datum do (opcionalno za otvoreno bolovanje)",
        type: "Tip bolovanja",
        otherType: "Dodatno pojašnjenje tipa bolovanja",
        otherTypePlaceholder: "Upišite pojašnjenje",
        attachment: "Doznaka (PDF, JPEG ili PNG, max 5 MB)",
        openHint: "Jedan klik = birate otvoreno ili jednodnevno bolovanje; dva klika = raspon.",
        openOption: "Otvoreno bolovanje",
        singleDayOption: "Bolovanje traje samo jedan dan",
        editTitle: "Uredi bolovanje",
        extendTitle: "Produži bolovanje",
        newEndDate: "Novi datum do (opcionalno)",
        newAttachment: "Nova doznaka",
        salaryPercentage: "Postotak naknade",
        salaryPercentageHint: "Zakonski minimum je 70 % osnovice. Viši postotak upišite ako je ugovoren ugovorom o radu, pravilnikom ili kolektivnim ugovorom.",
        types: {
          UP_TO_42_DAYS: "Do 42 dana (teret poslodavca)",
          OVER_42_DAYS: "Preko 42 dana (teret HZZO-a)",
          CHILD_CARE: "Njega djeteta",
          PREGNANCY_COMPLICATIONS: "Komplikacije u trudnoći",
          OCCUPATIONAL_INJURY: "Profesionalna bolest / ozljeda na radu",
          OSTALO: "Ostalo",
        },
      },
      other: {
        reason: "Navedi vrstu odsutnosti",
        reasonPlaceholder: "npr. sklapanje braka, rođenje djeteta ili smrt člana obitelji",
        hint: "Jedan klik = jednodnevna odsutnost; dva klika = raspon.",
        editTitle: "Uredi odsutnost",
      },
      longTermAbsence: {
        type: "Tip dugotrajne odsutnosti",
        rangeHint: "Odaberite razdoblje u kalendaru: prvi klik je datum početka, drugi datum završetka.",
        hint: "Tijekom dugotrajne odsutnosti zaposlenik nije u evidenciji radnog vremena — dnevni zapisi se ne generiraju i sati se ne unose. Po isteku razdoblja evidencija se automatski nastavlja.",
        masterOnly: "Dugotrajnu odsutnost može unijeti i mijenjati samo Master.",
        editEndDateTitle: "Uredi datum završetka",
        editEndDateHint: "Promijenite datum završetka za ranije ili kasnije vraćanje zaposlenika na rad.",
        newEndDate: "Novi datum do",
        types: {
          PREGNANCY_COMPLICATIONS: "Komplikacije u trudnoći",
          MATERNITY_LEAVE: "Rodiljni dopust",
          PARENTAL_LEAVE: "Roditeljski dopust",
          PATERNITY_LEAVE: "Očinski dopust",
          ADOPTION_LEAVE: "Posvojiteljski dopust",
          SEVERELY_DISABLED_CHILD_CARE: "Njega djeteta s težim smetnjama u razvoju",
          HALF_TIME_CHILD_CARE: "Rad s polovicom radnog vremena radi njege djeteta",
          PAID_LEAVE: "Plaćeni dopust",
          UNPAID_LEAVE: "Neplaćeni dopust",
          EMPLOYMENT_SUSPENSION: "Mirovanje radnog odnosa",
        },
      },
      list: {
        title: "Sve odsutnosti",
        empty: "Nema odsutnosti za ovog zaposlenika.",
        type: "Vrsta",
        period: "Razdoblje",
        currentPeriod: "Trenutno razdoblje",
        newPeriod: "Novo razdoblje",
        pendingChange: "Čeka odobrenje: {action}",
        amount: "Iznos",
        status: "Status",
        actions: "Akcije",
        open: "otvoreno",
      },
      validation: {
        required: "Ovo polje je obavezno",
        otherTypeRequired: "Ovo polje je obavezno kada je odabrano 'Ostalo'",
        dateNotPast: "Datum ne smije biti u prošlosti",
        endAfterStart: "Datum do ne smije biti prije datuma od",
        attachmentRequired: "Doznaka je obavezna",
        overlap: "Razdoblje se preklapa s postojećom odsutnošću zaposlenika.",
        startBeforeEmployment: "Datum ne smije biti prije datuma početka rada zaposlenika",
        startBeforeRegistration: "Datum početka odsutnosti ne može biti prije datuma prijave zaposlenika.",
      },
    },
    termination: {
      title: "Odjava zaposlenika",
      submit: "Pošalji odjavu",
      warning: "Ova akcija je trajna. Zaposlenik ostaje aktivan dok VOMI ne potvrdi odjavu.",
      confirmTitle: "Potvrda odjave",
      confirmMessage: "Jeste li sigurni da želite podnijeti odjavu zaposlenika?",
      confirmAccept: "Da, odjavi",
      confirmReject: "Odustani",
      success: "Odjava poslana — zaposlenik ostaje aktivan dok VOMI ne potvrdi.",
      pendingApproval: "Odjava poslana na odobrenje Masteru.",
      type: "Tip prestanka",
      date: "Datum prestanka",
      noticePeriodType: "Tip otkaznog roka",
      noticePeriodDays: "Broj dana otkaznog roka",
      vacationUsed: "Je li godišnji odmor iskorišten?",
      unusedVacationDays: "Broj neiskorištenih dana godišnjeg",
      vacationPreview: "Na dan {date} zaposleniku preostaje {days} {dayWord} godišnjeg odmora.",
      vacationPreviewError: "Nije moguće izračunati preostali godišnji za odabrani datum.",
      unusedVacationOption: "Opcija za neiskorišteni godišnji",
      daysToUse: "Dana za iskorištavanje",
      daysToPayout: "Dana za isplatu",
      misconductOptions: "Povrede obveza",
      misconductDescription: "Opis povrede",
      attachment: "Privitak (PDF, JPEG ili PNG, max 5 MB)",
      types: {
        MUTUAL_AGREEMENT: "Sporazumni raskid",
        FIXED_TERM_EXPIRY: "Istek ugovora na određeno",
        EMPLOYEE_INITIATED: "Otkaz radnika",
        PROBATIONARY_FAILURE: "Nezadovoljavanje na probnom radu",
        WORK_PERMIT_LOSS: "Gubitak radne dozvole",
        BUSINESS_REASONS_EMPLOYER: "Poslovno uvjetovani otkaz",
        EXTRAORDINARY_TERMINATION_EMPLOYEE: "Izvanredni otkaz radnika",
        EXTRAORDINARY_TERMINATION_EMPLOYER: "Izvanredni otkaz poslodavca",
        EMPLOYEE_MISCONDUCT_REGULAR: "Redoviti otkaz uvjetovan ponašanjem",
        RETIREMENT: "Odlazak u mirovinu",
        DEATH: "Smrt radnika",
      },
      noticePeriodTypes: {
        LEGAL: "Zakonski",
        AGREED: "Ugovoreni",
      },
      vacationOptions: {
        USE_IN_NOTICE_PERIOD: "Iskoristiti u otkaznom roku",
        PAYOUT: "Isplatiti",
        COMBINATION: "Kombinacija",
      },
      misconductTypes: {
        UNAUTHORIZED_ABSENCE: "Neopravdani izostanak s posla",
        REPEATED_VIOLATIONS: "Ponavljane povrede obveza",
        REFUSAL_OF_WORK: "Odbijanje rada",
        INTOXICATION: "Rad pod utjecajem alkohola/droga",
        THEFT_OR_DAMAGE: "Krađa ili nanošenje štete",
        BREACH_OF_CONFIDENTIALITY: "Povreda povjerljivosti",
        OTHER: "Ostalo",
      },
      validation: {
        required: "Ovo polje je obavezno",
        combinationSum: "Zbroj dana za iskorištavanje i isplatu mora biti jednak broju neiskorištenih dana.",
        attachmentRequired: "Privitak je obavezan za ovaj tip prestanka",
        attachmentTooLarge: "Datoteka je prevelika (maks. 5 MB)",
        dateOutOfRange: "Datum prestanka mora biti jučer (do 14 sati), danas ili kasnije, a najviše 30 dana unaprijed.",
      },
      resolution: {
        title: "Rješenje o raskidu",
        inProgress: "Odjava u tijeku",
        waiting: "Odjava poslana — VOMI priprema rješenje. Dokument će se pojaviti ovdje kad bude spreman.",
        subtitle: "Pregledajte rješenje i potpišite ga digitalno.",
        download: "Preuzmi",
        confirm: "Potpiši dokument",
        confirmedBadge: "Potpisano",
        confirmHint: "Potpisani dokument je spreman za preuzimanje i dostavu radniku.",
        confirmSuccess: "Dokument potpisan",
        downloadError: "Greška pri preuzimanju rješenja",
        confirmError: "Greška pri potpisivanju dokumenta",
      },
    },
    messages: {
      created: "Zaposlenik uspješno kreiran",
      updated: "Zaposlenik uspješno ažuriran",
      deactivated: "Zaposlenik uspješno deaktiviran",
      terminated: "Odjava zaposlenika uspješno poslana",
      archived: "Zaposlenik uspješno arhiviran",
      requestSent: "Zahtjev za dodavanje zaposlenika uspješno je poslan. Radnja će biti završena nakon odobrenja Mastera.",
      documentsMissing: "Dokumenti nisu poslani",
      bulkImported: "Uvezeno masovnim unosom",
      bulkImportedDocumentsReadonly: "Zaposlenik je unesen masovnim unosom. Dokumenti su već dostupni u Arhivi i ovdje ih nije moguće uređivati.",
    },
  },
  notifications: {
    title: "Obavijesti",
    taskStarted: "VOMI je započeo obradu",
    documentReady: "Dokument spreman za potpis",
    taskCompleted: "Radnja završena",
    employeeImportCompleted: "Uvoz zaposlenika dovršen",
    employeeImportUndone: "Uvoz zaposlenika poništen",
    reportReady: "Završni izvještaj spreman za potpis",
    contractExpiring: "Ugovor na određeno uskoro ističe",
    employeeNoteReminder: "Podsjetnik za zaposlenika",
    approvalApproved: "Dodavanje zaposlenika odobreno",
    approvalRejected: "Dodavanje zaposlenika nije odobreno",
    approvalRejectedReason: "Razlog: {reason}",
    employeeHardDeleted: "Zadatak i zaposlenik u pripremi su obrisani",
    employeeHardDeletedBody: "Zadatak „{action}” i zaposlenik u pripremi {name} trajno su obrisani.",
    employeeHardDeletedMessage: "Poruka Vomi korisnika: {message}",
    contractExpiringNote: "Ugovor ističe {date}. Riječ je o isteku ugovora, ne o zahtjevu za odjavu — molimo odlučite hoćete li ga produžiti ili zaposlenika odjaviti.",
    importSummary: "VOMI je uvezao {n} zaposlenika",
    employeeCreatedByVomi: "Novi zaposlenik kreiran",
    employeeCreatedByVomiBody: "Za vašu tvrtku kreiran je novi zaposlenik {name}. Podaci zaposlenika dostupni su u modulu Zaposlenici.",
    employeeCreatedByVomiWorkStart: " Datum početka rada: {date}.",
    importFailedSuffix: "{n} neuspjelih",
    importUndoneSummary: "VOMI je poništio uvoz — uklonjeno je {n} zaposlenika",
    openToConfirm: "Otvori za preuzimanje i potvrdu",
    employeeCorrected: "Podaci zaposlenika ispravljeni",
    employeeDeleted: "Zaposlenik uklonjen",
    correctedFieldsNote: "Izmijenjena polja: {fields}. Izvršio: {performedBy}.",
    deletedNote: "OIB {oib}. Izvršio: {performedBy}.",
    actionPrijava: "Prijava",
    actionPromjena: "Promjena",
    actionOdjava: "Odjava",
  },
  approvals: {
    title: "Zahtjevi za odobrenje",
    pendingTitle: "Zahtjevi na čekanju",
    noApprovals: "Nema zahtjeva na čekanju",
    approve: "Odobri",
    reject: "Odbij",
    confirmReject: "Potvrdi odbijanje",
    rejectionReason: "Razlog",
    rejectionReasonPlaceholder: "Unesite razlog odbijanja...",
    approved: "Zahtjev odobren",
    rejected: "Zahtjev odbijen",
    alreadyDecided: "Ovaj zahtjev je već obrađen.",
    newPending: "Novi zahtjev za odobrenje",
    actionCreate: "Prijava",
    actionUpdate: "Promjena",
    actionDelete: "Odjava",
    proposedData: "Predloženi podaci",
    currentData: "Trenutni podaci",
    field: "Polje",
    before: "Prije",
    after: "Poslije",
    employee: "Zaposlenik",
    action: "Akcija",
    requestedAt: "Zatraženo",
    contract: {
      title: "Uvjeti ugovora",
      jobTitle: "Radno mjesto",
      workingHours: "Radni sati",
      vacationDays: "Dani godišnjeg",
      salary: "Bruto plaća",
      desiredNetSalary: "Željeni neto iznos plaće",
      workLocation: "Mjesto rada",
      period: "Trajanje",
    },
    termination: {
      title: "Uvjeti odjave",
      type: "Vrsta",
      date: "Datum odjave",
      noticeDays: "Otkazni rok (dana)",
      unusedVacation: "Neiskorišteni godišnji",
      reason: "Obrazloženje",
    },
  },
  dashboard: {
    notification: {
      title: "Obavijesti",
      message:
        "Dobrodošli u novu verziju Vomi aplikacije! Sada možete lakše upravljati zaposlenicima i plaćama. Novi modul za digitalne izvještaje je sada dostupan!",
    },
    employees: {
      label: "Zaposlenici",
      active: "Aktivni",
    },
    payroll: {
      label: "Sljedeća plaća",
      notScheduled: "Nije zakazano",
    },
    recentActivity: {
      title: "Nedavna aktivnost",
      newEmployee: "Dodan novi zaposlenik",
      payrollCreated: "Kreirana isplata plaće",
      timesheetUpdated: "Ažurirana evidencija sati",
      daysAgo: "dana",
      noActivity: "Nema nedavne aktivnosti",
    },
  },
  payrollPage: {
    title: "Plaća",
    periodLabel: "Razdoblje",
    loading: "Učitavanje...",
    error: "Greška pri dohvaćanju podataka o obračunu.",
    retry: "Pokušaj ponovno",
    status: {
      title: "Status obračuna",
      month: "Mjesec obračuna",
      expectedPaymentDate: "Željeni datum isplate",
      label: "Status",
      notScheduled: "Još nije zakazano",
      TODO: "Zatraženo",
      IN_PROGRESS: "U tijeku",
      DONE: "Završeno",
    },
    hours: {
      title: "Radni sati",
      completeMessage: "Svi zaposlenici imaju unesene sate.",
      incompleteMessage: "Sljedeći zaposlenici još nemaju unesene sate za ovaj mjesec:",
      goToEmployee: "Otvori zaposlenika",
    },
    decisions: {
      title: "Nepotvrđene odluke",
      noneMessage: "Nema nepotvrđenih odluka za ovaj mjesec.",
      pendingMessage: "Za odabrani mjesec postoje odluke koje još nisu potvrđene. Prije zakazivanja obračuna plaće potrebno ih je potvrditi ili stornirati.",
      from: "od",
      types: {
        VACATION: "Godišnji odmor",
        SICK_LEAVE: "Bolovanje",
        LONG_TERM_ABSENCE: "Dugotrajna odsutnost",
        OTHER: "Ostala odsutnost",
        REGISTRATION: "Prijava zaposlenika",
        CONTRACT_CHANGE: "Izmjena ugovora",
        TERMINATION: "Odjava zaposlenika",
      },
    },
    schedule: {
      title: "Zakazivanje obračuna",
      dateLabel: "Željeni datum isplate",
      submit: "Zakaži obračun",
      resubmit: "Promijeni datum",
      blockedMessage: "Zakazivanje je moguće tek kad su uneseni sati svih zaposlenika.",
      paymentDeadlineWarning:
        "Prema Zakonu o radu, plaću je potrebno isplatiti najkasnije do 15. dana u mjesecu za prethodni mjesec, ako nije drugačije definirano ugovorom o radu ili kolektivnim ugovorom.",
      lockedMessage: "Radni sati i datum obračuna plaće nisu dostupni za uređivanje jer je obračun plaće u tijeku ili je završen. Za izmjene je potrebno kontaktirati Vomi d.o.o.",
      toast: {
        scheduled: "Obračun je uspješno zakazan.",
      },
    },
  },
  hoursPage: {
    title: "Sati",
    periodLabel: "Razdoblje",
    sortLabel: "Prezime",
    sortAsc: "A–Ž",
    sortDesc: "Ž–A",
    searchPlaceholder: "Pretraži zaposlenike…",
    noSearchResults: "Nema rezultata za traženi pojam.",
    error: "Greška pri dohvaćanju radnih sati.",
    retry: "Pokušajte ponovno",
    lockedMessage: "Radni sati i datum obračuna plaće nisu dostupni za uređivanje jer je obračun plaće u tijeku ili je završen. Za izmjene je potrebno kontaktirati Vomi d.o.o.",
    empty: "Nema podataka za odabrani period.",
    columns: {
      name: "Ime i prezime",
      regular: "Redovni",
      overtime: "Prekovremeni",
      night: "Noćni",
      vacation: "Godišnji (dani)",
      sickLeave: "Bolovanje (dani)",
      workingDays: "Radni dani",
      nonWorkingDays: "Neradni dani",
    },
    groups: {
      hours: "Sati",
      days: "Dani",
    },
    labels: {
      regular: "Redovni",
      overtime: "Prekovremeni",
      night: "Noćni",
      vacation: "Godišnji",
      sickLeave: "Bolovanje",
      working: "Radni",
      nonWorking: "Neradni",
    },
  },
  reports: {
    title: "Izvještaji",
    subtitle: "Pregledajte i digitalno potpišite svoje izvještaje.",
    empty: "Još nema dostupnih izvještaja.",
    yearTabLabel: "Završni izvještaji za {year}. godinu",
    searchPlaceholder: "Pretražite izvještaje…",
    noSearchResults: "Nema izvještaja koji odgovaraju vašoj pretrazi.",
    download: "Preuzmi",
    sign: "Potpiši dokument",
    statusSigned: "Potpisano",
    statusUnsigned: "Nepotpisano",
    signSuccess: "Dokument potpisan",
    signError: "Greška pri potpisivanju dokumenta",
    downloadError: "Greška pri preuzimanju izvještaja",
    loadError: "Greška pri dohvaćanju izvještaja",
    signatureRequired: "Postavite digitalni potpis u profilu da biste mogli potpisati izvještaje.",
    businessType: {
      llc: "d.o.o.",
      craft: "Obrt",
      association: "Udruga",
    },
  },
};
